"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = template;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _index = _interopRequireDefault(require("../style/index"));

var _react = _interopRequireDefault(require("react"));

var _IDate = _interopRequireDefault(require("../../../common/iObjects/IDate"));

var _Button = _interopRequireDefault(require("../../Button"));

var _l10n = _interopRequireDefault(require("../../../common/l10n"));

var _IconButton = _interopRequireDefault(require("../../IconButton"));

var _createStyled = _interopRequireDefault(require("../../../utils/createStyled"));

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _monthCount = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
    Div = _createStyled["default"].div(_templateObject()),
    Table = _createStyled["default"].table(_templateObject2()),
    Td = _createStyled["default"].td(_templateObject3()),
    Span = _createStyled["default"].span(_templateObject4());

function template() {
  var _this = this;

  var _this$props = this.props,
      _this$props$theme = _this$props.theme,
      DecreaseIcon = _this$props$theme.monthDecreaseIcon,
      IncreaseIcon = _this$props$theme.monthIncreaseIcon,
      yearChange = _this$props.yearChange,
      isPeriod = _this$props.isPeriod,
      layoutDate = this.state.layoutDate,
      year = layoutDate.get('year'),
      styles = this.compileStyled(_index["default"]),
      calendar = [];

  var nextYear = _react["default"].createElement("span", null),
      prevYear = _react["default"].createElement("span", null),
      controls = null,
      // calendar dates
  month,
      row,
      i = 0,
      j = 0,
      monthIndex = 0; // year change buttons


  if (yearChange) {
    prevYear = _react["default"].createElement(Div, {
      styles: styles.controlIcon
    }, _react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return _this._shift(-1);
      }
    }, _react["default"].createElement(DecreaseIcon, null)));
    nextYear = _react["default"].createElement(Div, {
      styles: styles.controlIcon
    }, _react["default"].createElement(_IconButton["default"], {
      onClick: function onClick() {
        return _this._shift(1);
      }
    }, _react["default"].createElement(IncreaseIcon, null)));
  }

  for (i; i < 4; i++) {
    j = 0;
    row = [];

    var _loop = function _loop() {
      month = _monthCount[monthIndex];
      monthIndex++;

      var date = new _IDate["default"]("01.".concat(month, ".").concat(year)).set({
        hours: 0,
        minutes: 0
      }),
          isStartSelected = _this._isStartOfPeriod(date),
          isEndSelected = _this._isEndOfPeriod(date);

      var periodOverlay = null,
          monthDOM = null,
          dateStyle = styles.date;

      if (_this._isDateInPeriod(date)) {
        var periodOverlayStyle = styles.period; // начало периода или первый месяц ряда

        if (isStartSelected || j === 0) {
          periodOverlayStyle = styles.periodStart;
        } // конец периода или последний месяц ряда


        if (isEndSelected || j === 2) {
          periodOverlayStyle = styles.periodEnd;
        } // исключение для показа маски


        if ( // начало периода выпало на конец ряда
        isStartSelected && j === 2 || // конец периода выпал на начало ряда
        j === 0 && isEndSelected || // период в 1 день
        _this._isOneDayPeriod()) {
          periodOverlayStyle = styles.periodNoFill;
        }

        periodOverlay = _react["default"].createElement(Div, {
          styles: periodOverlayStyle
        });
      }

      if (_this._isTodaySelected(date)) {
        dateStyle = styles.dateToday;
      }

      if (periodOverlay) {
        dateStyle = styles.datePassive;
      }

      if (isStartSelected || isEndSelected) {
        dateStyle = styles.dateSelected;
      }

      if (_this._isForbiddenDate(date)) {
        dateStyle = styles.dateDisabled;
      } // дата календаря


      monthDOM = _react["default"].createElement(Div, {
        styles: dateStyle,
        onClick: function onClick() {
          return _this.select(date);
        }
      }, date.toString('fs')); // календарь

      row.push(_react["default"].createElement(Td, {
        styles: styles.dateWrapper,
        key: "month-".concat(monthIndex)
      }, periodOverlay, monthDOM));
    };

    for (j; j < 3; j++) {
      _loop();
    }

    calendar.push(_react["default"].createElement("tr", {
      key: "row-".concat(i)
    }, row));
  }

  if (isPeriod) {
    controls = _react["default"].createElement("tr", null, _react["default"].createElement(Td, {
      colSpan: "7",
      styles: styles.calendarFooter
    }, _react["default"].createElement(Div, {
      styles: styles.calendarBtnCancel
    }, _react["default"].createElement(_Button["default"], {
      flatPrimary: true,
      onClick: this.cancel
    }, _l10n["default"].translate('MONTHPICKER_CANCEL'))), _react["default"].createElement(_Button["default"], {
      primary: true,
      onClick: this.submit
    }, _l10n["default"].translate('MONTHPICKER_OK'))));
  }

  return _react["default"].createElement(Div, {
    styles: styles.root,
    className: this.props.classList
  }, _react["default"].createElement(Div, {
    styles: styles.calendar
  }, _react["default"].createElement(Div, {
    styles: styles.calendarHead
  }, _react["default"].createElement("table", null, _react["default"].createElement("tbody", null, _react["default"].createElement("tr", null, _react["default"].createElement(Td, {
    colSpan: "7",
    styles: styles.control
  }, prevYear, _react["default"].createElement(Span, {
    styles: styles.controlYear
  }, year), nextYear))))), _react["default"].createElement(Div, {
    styles: styles.calendarBody
  }, _react["default"].createElement(Table, {
    styles: styles.calendar
  }, _react["default"].createElement("tbody", null, calendar), _react["default"].createElement("tfoot", null, controls)))));
}